function ResultsDirectionController($scope, $translate) {
  const labels = {
    edition: `${$translate.instant('SORT_PITCH_TIME')}:`,
    stories: `${$translate.instant('DIRECTION')}:`
  };

  $scope.label = labels[$scope.type];

  $scope.currentValue = $scope.filter.value || 'asc';

  $scope.options = [
    {
      value: 'asc',
      label: $translate.instant('CHRONOLOGICAL')
    },
    {
      value: 'desc',
      label: $translate.instant('REVERSE_CHRONOLOGICAL')
    }
  ];

  $scope.update = (val) => {
    $scope.filter.changeValue(val);
  };
}

const arr = [
  '$scope',
  '$translate',
  ResultsDirectionController
];

export default function (ngModule) {
  ngModule.controller('ResultsDirectionController', arr);
}
